export const getStartedRoutePath = '/get-started';
